import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-card" }
const _hoisted_3 = {
  key: 0,
  class: "login-loading"
}
const _hoisted_4 = {
  key: 1,
  class: "login-error"
}
const _hoisted_5 = {
  key: 2,
  class: "login-forgot"
}

import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import archiWebAuthService from '../services/archiweb.auth.service'
import AppButton from './base/AppButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

/// <reference types="vue" />
// @ts-ignore
const router = useRouter()
const isLoading = ref(true)
const errorMessage = ref<string | null>(null)

onMounted(async () => {
  try {
    await archiWebAuthService.login()
    // On success, redirect to user home or dashboard
    router.push('/')
  } catch (error) {
    console.error('Auto-login failed:', error)
    errorMessage.value = 'Failed to start login process'
    isLoading.value = false
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "login-brand",
        "aria-label": "Bati Vision 360 home"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            src: "/apple-touch-icon.png",
            alt: "Bati Vision 360"
          }, null, -1)
        ]))]),
        _: 1
      }),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "loading-spinner" }, null, -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('common.loading')), 1)
          ]))
        : _createCommentVNode("", true),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(errorMessage.value) + " ", 1),
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createVNode(AppButton, { variant: "outline" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.backToHome')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (!isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/reset-password",
              class: "forgot-password-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('auth.forgotPassword')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})